import React, {ReactNode} from 'react';

interface PopupDialogProps {
  children: ReactNode | ReactNode[] | string
}

const PopupDialog = (props: PopupDialogProps): JSX.Element => <div>{props.children}</div>;

export default PopupDialog;
